import { combineReducers } from '@reduxjs/toolkit';

import { city } from './city';
import { mainStats } from './mainStats';
import { region } from './region';
import { state } from './state';
import { typeCorporate } from './typeCorporate';
import { years } from './years';
import { currentVehicle } from './currentVehicle';
import { currencyRates } from './currencyRates';
import { currency } from './currency';
import { advertsCount } from './advertsCount';
import { vehicleReview } from './reviewSlice';
import { fuelPrices } from './fuelPricesSlice';
import { translate } from './translateSlice';
import { news } from './newsSlice';

export default combineReducers({
    advertsCount,
    city,
    state,
    years,
    region,
    typeCorporate,
    mainStats,
    currentVehicle,
    currencyRates,
    currency,
    vehicleReview,
    fuelPrices,
    translate,
    news,
});
